import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';



import Search from '../components/Search';
import ComponentFooter from '../components/Footer';
import AnimationFrame from "../lib/AnimationFrame";

import * as index from '../actions/index';
import * as global from '../actions/global';
import * as campaign from '../actions/campaign';

class Campaign extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      currentComponentFixedTop: null,
      currentComponentFixedRight: null,
      currentComponentFooter: null,
      componentPopup : null,

      addToCartPopup : null,

      currentComponentFetchHtml: null,
      currentComponentFetchTitle: null
    };
    this.animationControl = new AnimationFrame();
  }

  componentDidMount () {
    let { campaign } = this.props;
    /**
     * Require Fixed Top Right
     */
    // match
    let _pathname = browserHistory.getCurrentLocation().pathname;
    let _proId = browserHistory.getCurrentLocation().query.pro_id || null;
    if ( _pathname.match(/^\/campaign\/.+\/$/) ) {
      let params = {
        'pathname': _pathname
      };
      if(_proId){
        params = {
          'pathname': _pathname,
          'pro_id': _proId
        };
      }
      campaign.getCampaignContent(params, (callback) => {
        let { results } = callback;
        let { htmlDOM } = results;
        if(!htmlDOM){
          window.location.href="/error";
          return false;
        }
        this.setState({
          currentComponentFetchHtml: <div id="campaign" dangerouslySetInnerHTML={{ __html: htmlDOM }} />
        },() => {
          setTimeout(() => {
            $('#campaign script').each(function forEachScript() {
              const script = $(this).text();
              if(script.includes("proImg")){
                let editScript = script.replaceAll(`'+val.skuPic2+'`, `https://ssl1.sephorastatic.cn/soa/public/images/preload180509.png\"  class="sep_lazyload" data-original=\"'+val.skuPic2+'`);
                editScript = editScript.replaceAll(`loading(data);`,`
                  loading(data);
                  $("img.sep_lazyload").lazyload({
                    effect: "fadeIn",
                    placeholder: "https://ssl1.sephorastatic.cn/soa/public/images/preload180509.png",
                    skip_invisible : true
                  });
                `)
                window.eval(editScript);
              }else{
                window.eval(script);
              }
            })
          },500);
        })
      });
    }else{
      window.location.href="/error";
    }

    window.addEventListener('resize', this.handleResize.bind(this));
    window.addEventListener('scroll', this.handleScroll.bind(this));

    // 获取浏览器的尺寸
    this.handleFirstGet.bind(this)();
  }

  handleFirstGet () {
    let { global } = this.props;
    global.getGlobalWidth(window.innerWidth);
    global.getGlobalHeight(window.innerHeight);
    global.getGlobalScroll(document.body.scrollTop || document.documentElement.scrollTop);
  }

  handleResize (e) {
    let { global } = this.props;
    this.animationResize = this.animationControl.callRequestAnimationFrame(function(){
      global.getGlobalWidth(window.innerWidth);
      global.getGlobalHeight(window.innerHeight);
    });
  }

  handleScroll (e) {
    let { global } = this.props;
    this.animationScroll = this.animationControl.callRequestAnimationFrame(function(){
      global.getGlobalScroll(document.body.scrollTop || document.documentElement.scrollTop);
    })
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize.bind(this));
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    this.animationControl.callCancelAnimationFrame(this.animationResize);
    this.animationControl.callCancelAnimationFrame(this.animationScroll);
  }

  render () {
    let site = [],
    M_Search = <Search _Async={ true } key={ 'search' } />,
    currentComponentFooter = <ComponentFooter _View={true} key={'Footer'}/>;
    site.push( M_Search );
    site.push( this.state.currentComponentFetchHtml );
    site.push( currentComponentFooter );

    return (
      <div className="site">
        { site }
      </div>
    );

  }
}

export default connect(
  state => ({
    _global: state.global,
  }),
  dispatch => ({
    index: bindActionCreators(index, dispatch),
    global: bindActionCreators(global, dispatch),
    campaign: bindActionCreators(campaign, dispatch),
    dispatch
  })
)(Campaign);



// WEBPACK FOOTER //
// ./common/containers/Campaign.js